
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"7","cy":"7","r":"7","fill":"#C8C8C9"}}),_c('path',{attrs:{"fill":"#FFF","fill-rule":"nonzero","d":"M6.005 11c.467 0 .863-.137 1.19-.41.327-.273.613-.69.86-1.25L10.405 4h-1.61l-1.42 3.42L5.405 4h-1.81l3.01 5.01-.09.21c-.087.187-.26.28-.52.28a.875.875 0 01-.49-.17l-.56 1.36c.1.08.253.152.46.215.207.063.407.095.6.095z"}})])])
          )
        }
      }
    